// extracted by mini-css-extract-plugin
module.exports = {"h1":"Header_h1__lY6Qx","h2":"Header_h2__3CKJd"};